module.exports = __webpack_public_path__ + "static/media/merkantilbygg-logo.9e1af503.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/merkantilbygg-logo.jpg
// module id = 148
// module chunks = 0